import axios from "axios"

export default axios.create({
    baseURL: process.env.VUE_APP_BACK_URL,
});
